import { TGetUserListResDto } from "@/api/services/main/user/dtos/get-user-list.dto";
import { CACHED_TIME } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { truncateWithEllipsis } from "@/utils/string";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const fetchUserListPersonInChargeApi = async (): Promise<TGetUserListResDto> => {
  const rs = await clientApi.get<TGetUserListResDto>("/users/person-in-charge");
  return rs.data;
};

export const useGetUserListPersonInCharge = () => {
  const { data, ...rest } = useQuery({
    queryKey: [QUERY_KEYS.MATCH.FETCH_USER_LIST],
    queryFn: () => fetchUserListPersonInChargeApi(),
    staleTime: CACHED_TIME,
    gcTime: CACHED_TIME,
  });

  const userOptions = useMemo(
    () => (data ? data.data.map((item) => ({ label: truncateWithEllipsis(item.fullName, 50), value: item.id })) : []),
    [data],
  );

  return { data: data?.data ?? [], userOptions, ...rest };
};
